import React from 'react';
import { TopBar } from '../components/TopBar';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Ticker } from '../components/Ticker';
import { Mission } from '../components/Mission';
import { UseCases } from '../components/UseCases';
import { Materials } from '../components/Materials';
import { Product } from '../components/Product';
import { WhatsInBox } from '../components/WhatsInBox';
import { SocialProof } from '../components/SocialProof';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingElements } from '../components/FloatingElements';
import { ClassifiedProject } from '../components/ClassifiedProject';
import { AsSeenIn } from '../components/AsSeenIn';
export const Home = () => {
  return <div className="relative" data-id="element-1621" data-mp="3ow41nkdepyqj">
      <TopBar data-id="element-1622" data-mp="3ovavakid1b8x" />
      <Navigation data-id="element-1623" data-mp="3oyylb9oljfiw" />

      <main data-id="element-1624" data-mp="30wrn6awo3ncw">
        <Hero data-id="element-1625" data-mp="30xb9s4x9izx9" />
        <Ticker data-id="element-1626" data-mp="30x1eq2xd22kp" />
        <Mission data-id="element-1627" data-mp="30vgjeb382fls" />
        <AsSeenIn data-id="element-1628" data-mp="30w02hv4lza1e" />
        <UseCases data-id="element-1629" data-mp="30uf7y5ianr3j" />
        <WhatsInBox data-id="element-1630" data-mp="2vx6qk74yzr3c" />
        <Materials data-id="element-1631" data-mp="2vyq77yujg45n" />
        <Product data-id="element-1632" data-mp="2vy818ai2qbkj" />
        <Guarantee data-id="element-1633" data-mp="2vvlugd30c03d" />
        <FAQ data-id="element-1634" data-mp="2qylo0128wvbq" />
        <ClassifiedProject data-id="element-1635" data-mp="2qy2hdgi1ptd0" />
        <SocialProof data-id="element-1636" data-mp="2qxale4kjdtm7" />
        <Contact data-id="element-1637" data-mp="2qwsjarb70l6d" />
      </main>

      <Footer data-id="element-1638" data-mp="2mxa8iod35qh9" />
      <FloatingElements data-id="element-1639" data-mp="2mxjork8bwj9r" />
    </div>;
};